import React from "react"
import { useTranslation } from "react-i18next"

import PublicLayout from "components/Layout/PublicLayout"
import { useOperator } from "hooks"

import { Seo } from "components/Seo"
import { importView, isNotEmpty } from "utils"

export const SignupPage: React.FC = () => {
	const [view, setView] = React.useState(null)
	const { t } = useTranslation()
	const { currentOperator, isOperatorComplete } = useOperator()

	React.useEffect(() => {
		if (isOperatorComplete && !isNotEmpty(view)) {
			const loadView = async () => {
				const componentPromises: any = [currentOperator].map((operator) => {
					const SignupView = importView(operator, "Signup")
					return <SignupView key={operator.id} />
				})
				await Promise.all(componentPromises).then(setView).catch(console.error)
			}
			loadView()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentOperator])

	return (
		<PublicLayout>
			<div className="max-w-screen-3xl mx-auto">
				{currentOperator && (
					<Seo
						title={t("signup_title", {
							ns: "seo",
							operator: currentOperator.name,
						})}
						description={t("signup_description", {
							ns: "seo",
							operator: currentOperator.name,
						})}
					/>
				)}
				<React.Suspense fallback="Loading logo...">{view}</React.Suspense>
			</div>
		</PublicLayout>
	)
}
